import { useState, useEffect } from "react";

export default function useWindowSize() {
  const windowAvailable = typeof window !== "undefined";
  const [windowSize, setWindowSize] = useState({
    width: windowAvailable ? window.innerWidth : 1200,
    height: windowAvailable ? window.innerHeight : 800
  });

  const resizeHandler = () =>
    setWindowSize({ width: window.innerWidth, height: window.innerHeight });

  // Bind the event listener
  const setup = () =>
    windowAvailable && window.addEventListener("resize", resizeHandler);
  // Unbind the event listener on clean up
  const teardown = () =>
    windowAvailable && window.removeEventListener("resize", resizeHandler);

  useEffect(() => {
    setup();
    return teardown;
  });

  return windowSize;
}
